import { useEffect, useState } from 'react';
import { useDebounceCallback } from '@react-hook/debounce';
import mockData from '../mock/groupDashboard.mock';
import { flattenTree } from 'components/base/MultiLevelDropdown/MultiLevelDropdown.utils';
import {
  convertMetricsNameToV3,
  getDashboardMetricsV3
} from 'common/services/metrics.service';
import { VIEW_PATH_KEYS } from 'common/constants/constants';
import { getIsGitScopeByKey } from 'components/TeamGitScopeBanner/utils';

// need to pass gitScopeToggle from all places
const useGroupMetrics = ({
  metricsNames = [],
  dates,
  metricsCalculationStrategy,
  selectedGroup,
  roll_up = 'custom',
  shouldGetOnlySelectedGroupData = false,
  gitScopeToggle = null
}) => {
  const [metrics, setMetrics] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const selectedGroupId = selectedGroup?.[0]?.id;
  const isMockEnv = false;
  let teamIds;

  if (shouldGetOnlySelectedGroupData) {
    teamIds = [selectedGroupId];
  } else {
    const flatTree = flattenTree(selectedGroup, 'children');
    teamIds = flatTree.map(({ id }) => id).filter(id => id !== selectedGroupId);
  }

  const mockValues = roll_up => {
    if (roll_up === 'custom') {
      return mockData.groupMetrics;
    }
    return mockData.metricsDataOneDayRollUp;
  };

  const handleFetchErrors = error => {
    return error?.response?.data?.description ?? '';
  };

  const fetchGroupsMetrics = async () => {
    try {
      const res = isMockEnv
        ? mockValues(roll_up)
        : await getDashboardMetricsV3({
            time_ranges: [{ after: dates.from, before: dates.to }],
            requested_metrics: convertMetricsNameToV3(
              metricsNames,
              metricsCalculationStrategy
            ),
            teamId: teamIds,
            offset: 0,
            return_no_data: true,
            roll_up,
            ...(gitScopeToggle !== null
              ? {
                  team_git_scope_disabled: !getIsGitScopeByKey(
                    gitScopeToggle,
                    VIEW_PATH_KEYS.DASHBOARD
                  )
                }
              : {})
          });
      setMetrics(res);
    } catch (e) {
      handleFetchErrors(e);
    }
    setIsLoading(false);
  };

  const debouncedFilterEntities = useDebounceCallback(fetchGroupsMetrics, 800);

  useEffect(() => {
    setIsLoading(true);
    debouncedFilterEntities();
  }, [dates?.from, dates?.to, selectedGroupId, metricsNames, gitScopeToggle]);

  return {
    metrics,
    isLoading
  };
};

export default useGroupMetrics;
